module.exports = __webpack_public_path__ + "img/vicky.895cc310.png";